import UploadProductsForm from "@/components/multi-step-forms/upload-products";
import { Button } from "@/components/ui/button";
import { buildMetadata } from "@/lib/metadata";
import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/_main/upload-products")({
  component: RouteComponent,
  head: () => ({
    meta: buildMetadata({
      title: "Upload Products",
      description: "Upload products to OpenFarming",
      keywords: ["upload", "products", "openfarming"],
    }),
  }),
});

function RouteComponent() {
  return (
    <div className="container max-w-7xl p-4">
      <Button variant="ghost" className="mb-8">
        <ArrowLeft />
        <a href="/">Go back to dashboard</a>
      </Button>

      <UploadProductsForm />
    </div>
  );
}
